import { render } from "./KTDatatable.vue?vue&type=template&id=ef3fee1e&scoped=true&ts=true"
import script from "./KTDatatable.vue?vue&type=script&lang=ts"
export * from "./KTDatatable.vue?vue&type=script&lang=ts"

import "./KTDatatable.vue?vue&type=style&index=0&id=ef3fee1e&lang=scss&scoped=true"
import "./KTDatatable.vue?vue&type=style&index=1&id=ef3fee1e&lang=css"
import "./KTDatatable.vue?vue&type=style&index=2&id=ef3fee1e&lang=scss"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef3fee1e"]])

export default __exports__